export enum TopActions {
  Selector = 0,
  Toolbox,
  DrawLine,
}

export enum BottomActions {
  Nothing = 0,
  Arrow,
  Icon,
  Text,
  DrawLine,
  Circle,
}

export enum SubActions {
  Nothing = 0,
  LineColor,
  LineStrokeWidth,
  LineArrowHead,
  LineDashArray,
  Icon,
  TextColor,
  TextBackgroundColor,
}
